"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = require("react-emotion");

var _themeConfig = _interopRequireDefault(require("@lyearn-team/theme-config"));

var main = function main(breakpoint) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:flex;padding:7px 10px;margin:0 auto;background-color:", _themeConfig.default.color.dark.mars, ";@media (max-width:", breakpoint, "){flex-direction:column;}")
  );
};

var radioButton = function radioButton(breakpoint) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("flex-direction:column;color:", _themeConfig.default.color.dark.silver, " !important;padding:0px 15px;text-align:center;div{margin:0;}@media (max-width:", breakpoint, "){margin-bottom:12px;flex-direction:row;div{margin-right:8px;}}")
  );
};

var _default = {
  main: main,
  radioButton: radioButton
};
exports.default = _default;